export default __webpack_public_path__ + "static/media/laundry1-beforeA.ca862927.jpg";